<template>
  <!-- Sidebar -->
  <ul class="sidebar navbar-nav toggled">
    <li class="nav-item active">
      <RouterLink
        class="nav-link"
        to="/"
      >
        <i class="fas fa-fw fa-home" />
        <span>{{ $t('JSON.home') }}</span>
      </RouterLink>
    </li>
    <li class="nav-item">
      <RouterLink
        class="nav-link"
        to="/history-page"
      >
        <i class="fas fa-fw fa-history" />
        <span>{{ $t('JSON.history-page') }}</span>
      </RouterLink>
    </li>
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle"
        href="#"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="fas fa-fw fa-list-alt" />
        <span>{{ $t('JSON.categories') }}</span>
      </a>
      <div class="dropdown-menu">
        <RouterLink
          class="dropdown-item"
          to="/categories"
        >
          Movie
        </RouterLink>
        <RouterLink
          class="dropdown-item"
          to="/categories"
        >
          Music
        </RouterLink>
        <RouterLink
          class="dropdown-item"
          to="/categories"
        >
          Television
        </RouterLink>
      </div>
    </li>
    <li class="nav-item channel-sidebar-list">
      <h6>{{ $t('JSON.subscriptions') }}</h6>
      <ul>
        <li>
          <RouterLink to="/subscriptions">
            <img
              class="img-fluid"
              alt=""
              src="@/assets/theme/img/s1.png"
            > Your Life
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/subscriptions">
            <img
              class="img-fluid"
              alt=""
              src="@/assets/theme/img/s2.png"
            > Unboxing <span class="badge badge-warning">
              2
            </span>
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/subscriptions">
            <img
              class="img-fluid"
              alt=""
              src="@/assets/theme/img/s3.png"
            > Product / Service
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/subscriptions">
            <img
              class="img-fluid"
              alt=""
              src="@/assets/theme/img/s4.png"
            > Gaming
          </RouterLink>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint-disable no-undef */

export default {

  mounted() {
    this.initGui();
  },
  methods: {
    initGui() {
      // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
      $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function (e) {
        if ($window.width() > 768) {
          const e0 = e.originalEvent;
          const delta = e0.wheelDelta || -e0.detail;
          this.scrollTop += (delta < 0 ? 1 : -1) * 30;
          e.preventDefault();
        }
      });
    },
  },
};
</script>
